import React, { useState } from "react";
import WaitListModal from "./MagicAIjoinWaitlistModal";
import Faqs from "../components/Home/Faqs";

export default function MagicAI() {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleJoinWaitlist = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="bg-gradient-to-bl from-rose-900 via-red-400 to-indigo-600 flex flex-col justify-center items-center h-screen text-black">
        <h1 className="text-7xl font-bold">MagicAI</h1>
        <h2 className="my-10 font-josefin-sans font-semibold text-3xl text-center text-white">
          Feel the magic of AI with MagicAI
        </h2>
      </div>
      <div className=" mt-28 mx-5 flex flex-col justify-center items-center lg:mx-44">
        <div className="">
          <div className="head">
            <p className="text-2xl lg:text-5xl font-bold mt-32 text-center">
              The powerful and accurate Generative AI tool to solve STEM
              (science, technology, engineering and mathematics) problems
              instantly.
            </p>
          </div>
          <div className="my-60">
            <h2 className="font-titillium-web text-5xl font-bold mt-20  text-center">
              Accuracy
            </h2>
            <p className="mt-5 text-3xl text-center">
              MagicAI can solve difficult STEM problems with greater accuracy,
              thanks to its domain-specific knowledge of topics in the field of
              STEM and problem-solving abilities.
            </p>
          </div>

          <div className="my-60">
            <h2 className="font-titillium-web text-5xl font-bold mt-20 text-center">
              Prompt
            </h2>
            <p className="mt-5 text-3xl text-center">
              From texts to images to extended content, the prompts in the
              MagicAI are adaptive while providing a much better output.
            </p>
          </div>
          <div className="py-44 font-josefin-sans bg-black text-white text-center text-4xl p-10 rounded-xl">
            We are leveraging deep learning to create advanced reasoning and
            problem-solving capabilities with MagicAI.
          </div>
          <div className="mt-60">
            <h2 className="font-titillium-web text-5xl font-bold mt-20 text-center">
              Limitations
            </h2>
            <p className="mt-5 text-3xl text-center">
              MagicAI has known limitations that we are working hard to mitigate
              and provide users with much less hallucinations in getting
              solutions to a problem.
            </p>
          </div>
        </div>
        <button
          onClick={handleJoinWaitlist}
          className="mt-20 lg:mt-44 mb-28 lg:mb-44 px-5 py-3 bg-gradient-to-bl from-rose-900 via-red-400 to-indigo-600 text-white font-titillium-web rounded-lg font w-36 "
        >
          Join Waitlist
        </button>

        {/* Edit Profile Modal */}
        {isModalOpen && <WaitListModal closeModal={closeModal} />}
      </div>
      <Faqs />
    </>
  );
}
